import type { DeltafaceBuffers, DeltafaceConfig } from './types';
import {
  createDeltafaceConfig,
  loadGingivaSteps,
  loadIprsData,
  loadOptionalMeshes,
  loadSequenceInfo,
  loadStartGingiva,
  parseToothFile,
} from './utils';

export function getToothGingivaType(toothNumber: number): 0 | 1 | -1 {
  if (toothNumber >= 0 && toothNumber <= 16) return 1;
  else if (toothNumber >= 17) return 0;
  return -1;
}

export function buildDeltafaceConfig(
  files: DeltafaceBuffers,
  onProgress?: (progress: number) => void
): DeltafaceConfig {
  let count = 0;
  const total = Object.keys(files).length;
  let config = createDeltafaceConfig();

  const incrementProgress = () => {
    count++;
    onProgress?.(count / total);
  };

  if (files.SEQUENCE_INFOS) {
    let sequenceData = loadSequenceInfo(files.SEQUENCE_INFOS);
    config.frames = sequenceData.frames;
    config.hasIpr = sequenceData.hasIpr;
    config.iprValues = sequenceData.iprValues;
    config.optionalMeshesFrames = sequenceData.optionalMeshesFrames;
    config.optionalMeshesToothNumbers = sequenceData.optionalMeshesToothNumbers;
    for (let [key, value] of sequenceData.optionalMeshesTypes) {
      config.optionalMeshesTypes.set(key, value);
    }
    config.optionalMeshesVisible = sequenceData.optionalMeshesVisible;
    config.totalSteps = sequenceData.totalSteps;
    config.visibleIprs = sequenceData.visibleIprs;
    incrementProgress();
  }

  if (files.TEETH) {
    let toothData = parseToothFile(files.TEETH);
    config.missingTeeth.push(...toothData.missingTeeth);
    for (let [key, value] of toothData.teeth) config.teeth.set(key, value);
    incrementProgress();
  }

  if (files.START_GINGIVAS) {
    let startGingivaData = loadStartGingiva(files.START_GINGIVAS);
    config.posStartGingivas = startGingivaData.posStartGingivas;
    for (let [key, value] of startGingivaData.gingivas) {
      config.gingivas.set(key, value);
    }
    incrementProgress();
  }

  if (files.OPTIONAL_MESHES) {
    let optionalMeshesData = loadOptionalMeshes(files.OPTIONAL_MESHES);
    config.optionalMeshes = optionalMeshesData.optionalMeshes;
    config.optionalMeshesTypes = optionalMeshesData.optionalMeshesTypes;
    config.numbers = optionalMeshesData.numbers;
    config.wiresMandible = optionalMeshesData.wiresMandible;
    config.wiresMaxilla = optionalMeshesData.wiresMaxilla;
    incrementProgress();
  }

  if (files.GINGIVAS_STEPS) {
    let gingivaStepsData = loadGingivaSteps(files.GINGIVAS_STEPS);
    config.mandibleGingivas = gingivaStepsData.mandibleGingivas;
    config.maxillaGingivas = gingivaStepsData.maxillaGingivas;
    incrementProgress();
  }

  if (files.IPRS_DATA) {
    let iprsData = loadIprsData(files.IPRS_DATA);
    config.iprPointsScene = iprsData.iprPointsScene;
    incrementProgress();
  }
  return config;
}
